<script>
export default {
  data() {
    return {
      password: '',
      confirm: '',
      errors: null
    }
  },
  computed: {
    approvedPassword() {
      if ((this.password !== '' && this.confirm !== '') && this.password === this.confirm) {
        this.errors = ''
        this.$emit('success', {
          password: this.password,
          confirm: this.confirm
        })
        return this.password
      } else if (this.password !== '' && this.confirm !== '') {
        this.$emit('errors', {message: "Uh oh, the passwords don't match. Please try again."})
        this.errors = "Uh oh, the passwords don't match. Please try again."
      }
      return null
    }
  },
  render() {
    return this.$scopedSlots.default({
      errors: this.errors,
      pwProps: {
        value: this.password
      },
      pwEvents: {
        focusout: e => (this.password = e.target.value)
      },
      pwcProps: {
        value: this.approvedPassword
      },
      pwcEvents: {
        focusout: e => (this.confirm = e.target.value)
      },
    })
  }
}
</script>
